<template>
  <div style="max-height:none !important;">
    <vs-table
      :data="Prerequisites"
      v-if="Prerequisites != null && Prerequisites.length > 0"
    >
      <template slot="thead">
        <vs-th></vs-th>
        <vs-th>Item:</vs-th>
        <vs-th>Comment:</vs-th>
        <vs-th>Actions:</vs-th>
      </template>
      <template slot-scope="{ data }">
        <tbody>
          <vs-tr
            :data="relationItem"
            :key="indextr"
            v-for="(relationItem, indextr) in Prerequisites"
          >
            <vs-td>
              <FeatherIcon v-if="relationItem && relationItem.TargetType == 'DataModel.TCVelik.Embed.TCEmbed'"
                icon="BookOpenIcon"
              >
              </FeatherIcon>
              <FeatherIcon v-else-if="relationItem && relationItem.TargetType == 'DataModel.TCVelik.Skill.TCSkillCategory'"
                icon="AwardIcon"
              >
              </FeatherIcon>
            </vs-td>
            <vs-td>
              <a :href="'/dashboard/people/' + ForUser.Id + '/details?catIds=' + relationItem.TargetItem.Id">{{ relationItem.TargetItem.Title }}</a><br />
              <span style="font-size: 11px">{{
                relationItem.TargetItem.FullPath
              }}</span>
            </vs-td>
            <vs-td>
              {{ relationItem.Comment }}
            </vs-td>
            <vs-td>
              <a v-if="relationItem.Id < 1" @click="SaveRelation(relationItem)">Save</a>
              <a v-else @click="DeleteRelation(relationItem.Id)" class="text-danger">Delete</a>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <div v-else style="min-height: 100px">
      No prereqs found. <a @click="GetAiSkills(true)">Get and cache</a> or
      <a @click="GetAiSkills(false)">Get fresh analysis</a>
      <br />
      {{ CurrentState }}
    </div>
  </div>
</template>

<script>
import FeatherIcon from "../../../../components/FeatherIcon.vue";
import skillsService from "@/skills/skillsService.js";
import OpenAiClient from "@/openai/OpenAIClient.js";
import relationsService from "@/relations/relationsService.js";

export default {
  data() {
    return {
      CurrentState: "",
      SkillCategories: [],
    };
  },
  methods: {
    async GetAiSkills(bCanCache) {

      var instance = this;

      this.CurrentState = "Getting categories of skills ...";

      if (!this.SkillCategories || this.SkillCategories.length == 0) {
        var result = await skillsService.GetSkillWithBreadCrumbs();
        this.CurrentState =
          "Looing in " + result.data?.Categories?.length + " of skills ...";
        this.SkillCategories = result.data?.Categories;
      }
      // Waiting for AI:
      this.CurrentState = "Waiting for AI to analyze them ...";

      var articleDiv = document.createElement("div");
      articleDiv.innerHTML = this.AnalyzedArticle.Description;
      var textOnly = articleDiv.innerText;

      var prompt =
        "Given the article here:\n" +
        "Title: \n" +
        this.AnalyzedArticle.Title +
        "\n" +
        "Content:\n" +
        textOnly +
        "\n\n" +
        "Knowing I am content editor, web admin and developer " +
        "select the skills I need (only that apply to the article) and provide them in the following format: " +
        '{"c": -1 // The Id of the skills category \n, "expl": "the explanation on why the category is needed and for which roles."}\n\n' +
        "Reply only with this JSON, or empty array if error or nothing is found!\n\n" +
        "Here is a list of skill categories to choose from: \n" +
        JSON.stringify(this.SkillCategories);

      var aiResult = await OpenAiClient.promptRaw(
        prompt,
        "AI_SKILLS_" + this.AnalyzedArticle.Id,
        bCanCache
      );
      this.CurrentState = "Unpacking AI Response...";
      var data = aiResult.data;

      if (data && data.length > 0) {
        var res = JSON.parse(data).choices[0].message.content;
        var final = JSON.parse(res);

        if (final && final.length > 0) {
          var categoriesSelected = this.SkillCategories.filter(function (item) {
            return final.filter((f) => f.c == item.Id).length > 0;
          });

          var itemsToAdd = [];
          for (var i = 0; i < categoriesSelected.length; i++) {
            var selectedCategory = categoriesSelected[i];


            itemsToAdd.push({
              Id: 0,
              TargetItem: {
                Title: selectedCategory.Title,
                Id: selectedCategory.Id,
                FullPath: selectedCategory.FullPath
              },
              TargetItemId: selectedCategory.Id,
              TargetType: "DataModel.TCVelik.Skill.TCSkillCategory",
              Comment: final.filter((f) => f.c == selectedCategory.Id)[0]
                  .expl,
              SourceItemId: instance.SourceItemId,
              SourceType: instance.SourceType,
              RelationType: instance.RelationType
            });
          }

          this.$emit("PrerequisitesAdded", itemsToAdd);
        }
      }
    },
    SaveRelation(relationItem){
      var relItem = relationItem;
      var instance = this;
      relationsService.SaveRelations([relItem]).then(function(response){
        var savedItemId = response.data[0].Id;
        instance.$set(relItem, "Id", savedItemId);
      });
    },
    DeleteRelation(id){
      var instance = this;
      relationsService.DeleteRelation(id).then(function(response){
        var newItems = instance.Prerequisites.filter(f => f.Id != id);
        instance.$emit("PrerequisitesAdded", newItems);
      });
    }
  },
  components: {
    FeatherIcon,
  },
  mounted() {},
  props: ["Prerequisites", "AnalyzedArticle", "ForUser", "SourceType", "SourceItemId", "RelationType"],
};
</script>
